/**
 * Global Styles
 * 
 * Application-wide CSS styles using styled-components createGlobalStyle.
 * Defines typography, base element styling, and responsive design foundations.
 * 
 * Interactions:
 * - Uses Google Fonts for custom typography (Merriweather, Motiva Sans)
 * - Defines global color scheme and brand colors throughout the app
 * - Sets responsive breakpoints and base styling for all HTML elements
 * - Provides form input styling and focus states
 * - Integrates with antd component library styling
 * - Applied at the router level to affect all pages and components
 */

import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;600;700&display=swap');

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
    }

    a:hover {
        color: rgb(23, 22, 21);
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow:rgba(209, 174, 76, 1)
 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Merriweather', serif;
        font-weight: 600;
        color:rgb(23, 22, 21);
        font-size: 54px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 45px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 30px;
        }
    }

    p {
        color: rgb(23, 22, 21);
        font-size: 19px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: rgba(209, 174, 76, 1)
;

        :hover {
            color: rgba(209, 174, 76, 1)
;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
